import config from './config'

export const BillingAPI = {
    createManageUrl: () => {
        return config.post('/api/merchant/billing/')
    },
}
